import { useDispatch } from 'react-redux';
import { eventActions } from '../../../../store/modules/event';

const useExcel = (allEvent) => {
  const dispatch = useDispatch();

  /**
   * 엑셀 다운로드
   */
  const getExcelDownload = () => {
    const { filterOption } = allEvent.allEventList;

    dispatch(
      eventActions.getAllEventExcelDownload({
        filterOption,
      }),
    );
  };

  return {
    getExcelDownload,
  };
};

export default useExcel;
